import { render, staticRenderFns } from "./TaskSelect.vue?vue&type=template&id=1020965e&scoped=true&"
import script from "./TaskSelect.vue?vue&type=script&lang=js&"
export * from "./TaskSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaskSelect.vue?vue&type=style&index=0&id=1020965e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020965e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1020965e')) {
      api.createRecord('1020965e', component.options)
    } else {
      api.reload('1020965e', component.options)
    }
    module.hot.accept("./TaskSelect.vue?vue&type=template&id=1020965e&scoped=true&", function () {
      api.rerender('1020965e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/TaskSelect.vue"
export default component.exports